import { FlaskConical } from "lucide-react";
import { cn } from "@/lib/utils";

/** Liten markering som visar att auktioner bara finns på dev/förhandsvisning. */
export function AuctionDevBadge({ className }: { className?: string }) {
  return (
    <span
      title="Auktioner visas bara på dev och förhandsvisning – inte på den publika sajten."
      className={cn(
        "inline-flex h-6 items-center gap-1 rounded-md border border-amber-500/40 bg-amber-500/15 px-2 text-[10px] font-semibold uppercase tracking-wide text-amber-500",
        className,
      )}
    >
      <FlaskConical className="h-3 w-3" /> Endast dev
    </span>
  );
}
